/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
    FindAllSourceTags200ResponseDataInnerToJSONTyped,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * 
 * @export
 * @interface AutoDecisioningOptions
 */
export interface AutoDecisioningOptions {
    /**
     * 
     */
    payers: Array<FindAllSourceTags200ResponseDataInner>;
    /**
     * 
     */
    payer_types: Array<string>;
    /**
     * Connectors available to the organization
     */
    platforms: Array<string>;
    /**
     * 
     */
    subsystems: Array<string>;
}

/**
 * Check if a given object implements the AutoDecisioningOptions interface.
 */
export function instanceOfAutoDecisioningOptions(value: object): value is AutoDecisioningOptions {
    if (!('payers' in value) || value['payers'] === undefined) return false;
    if (!('payer_types' in value) || value['payer_types'] === undefined) return false;
    if (!('platforms' in value) || value['platforms'] === undefined) return false;
    if (!('subsystems' in value) || value['subsystems'] === undefined) return false;
    return true;
}

export function AutoDecisioningOptionsFromJSON(json: any): AutoDecisioningOptions {
    return AutoDecisioningOptionsFromJSONTyped(json, false);
}

export function AutoDecisioningOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoDecisioningOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'payers': ((json['payers'] as Array<any>).map(FindAllSourceTags200ResponseDataInnerFromJSON)),
        'payer_types': json['payer_types'],
        'platforms': json['platforms'],
        'subsystems': json['subsystems'],
    };
}

export function AutoDecisioningOptionsToJSON(json: any): AutoDecisioningOptions {
    return AutoDecisioningOptionsToJSONTyped(json, false);
}

export function AutoDecisioningOptionsToJSONTyped(value?: AutoDecisioningOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payers': ((value['payers'] as Array<any>).map(FindAllSourceTags200ResponseDataInnerToJSON)),
        'payer_types': value['payer_types'],
        'platforms': value['platforms'],
        'subsystems': value['subsystems'],
    };
}

